/* VD button — the magnet and the light of .vd-btn. The button leans toward the mouse, a soft light follows
   the mouse inside it, and it shines once when it first comes into view. Progressive enhancement: without
   this file the button still works. Mouse only for the magnet and the light; nothing moves with "reduce motion".
   Arrow and press are plain CSS (assets/vd-quiet.css). */
(function () {
  'use strict';
  if (window.__vdbtn) return; window.__vdbtn = true;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* ---------------- one shine when it first comes into view ---------------- */
  if ('IntersectionObserver' in window) {
    var seen = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-seen');
        seen.unobserve(en.target);
      });
    }, { threshold: 0.9 });
    var watch = function (scope) { (scope || document).querySelectorAll('.vd-btn:not(.is-seen)').forEach(function (b) { seen.observe(b); }); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { watch(); }); else watch();
    document.addEventListener('shopify:section:load', function (e) { watch(e.target); });
  }

  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  /* ---------------- magnet + light ---------------- */
  var PULL = 0.3, MAX = 14, EASE = 0.16; // share of the distance to the mouse, largest step in px, speed of the spring
  var moving = [], running = false, current = null;

  function state(el) {
    if (!el.__vdb) el.__vdb = { el: el, x: 0, y: 0, tx: 0, ty: 0 };
    return el.__vdb;
  }
  function clamp(v) { return Math.max(-MAX, Math.min(MAX, v)); }
  function wake(s) {
    if (moving.indexOf(s) < 0) { moving.push(s); s.el.classList.add('is-magnet'); }
    if (!running) { running = true; requestAnimationFrame(tick); }
  }
  function tick() {
    moving = moving.filter(function (s) {
      s.x += (s.tx - s.x) * EASE;
      s.y += (s.ty - s.y) * EASE;
      var rest = Math.abs(s.tx - s.x) < 0.05 && Math.abs(s.ty - s.y) < 0.05;
      if (rest) { s.x = s.tx; s.y = s.ty; }
      s.el.style.setProperty('--vd-bx', s.x.toFixed(2) + 'px');
      s.el.style.setProperty('--vd-by', s.y.toFixed(2) + 'px');
      if (rest && s.tx === 0 && s.ty === 0) { s.el.classList.remove('is-magnet'); return false; }
      return !rest;
    });
    if (moving.length) requestAnimationFrame(tick); else running = false;
  }
  function release() {
    if (!current) return;
    current.tx = 0; current.ty = 0;
    wake(current);
    current = null;
  }

  document.addEventListener('pointermove', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    var el = e.target.closest ? e.target.closest('.vd-btn') : null;
    if (el && el.disabled) el = null;
    if (!el) { release(); return; }
    if (current && current.el !== el) release();
    var s = state(el);
    current = s;
    var r = el.getBoundingClientRect();
    // the rect already contains the current offset: take it out, or the button chases its own tail
    var left = r.left - s.x, top = r.top - s.y;
    s.tx = clamp((e.clientX - (left + r.width / 2)) * PULL);
    s.ty = clamp((e.clientY - (top + r.height / 2)) * PULL);
    el.style.setProperty('--vd-lx', (e.clientX - r.left).toFixed(1) + 'px');
    el.style.setProperty('--vd-ly', (e.clientY - r.top).toFixed(1) + 'px');
    wake(s);
  }, { passive: true });
  document.documentElement.addEventListener('pointerleave', release);
  window.addEventListener('blur', release);
})();
